import { useEffect, useRef, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useLang } from "@/i18n";

export const LanguageTransition = () => {
  const { lang } = useLang();
  const [state, setState] = useState({ playing: false, label: "" });
  const prev = useRef(lang);
  const first = useRef(true);

  useEffect(() => {
    if (first.current) {
      first.current = false;
      prev.current = lang;
      return;
    }
    if (prev.current === lang) return;
    prev.current = lang;

    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return;

    setState({ playing: true, label: lang.toUpperCase() });
    const t = setTimeout(() => setState((s) => ({ ...s, playing: false })), 850);
    return () => clearTimeout(t);
  }, [lang]);

  return (
    <AnimatePresence>
      {state.playing && (
        <motion.div
          key="lang-wipe"
          className="fixed inset-0 z-[90] flex items-center justify-center bg-[var(--bg-0)] border-l border-[var(--accent)]"
          initial={{ clipPath: "inset(0 100% 0 0)" }}
          animate={{ clipPath: "inset(0 0% 0 0)" }}
          exit={{ clipPath: "inset(0 0 0 100%)" }}
          transition={{ duration: 0.5, ease: [0.76, 0, 0.24, 1] }}
          data-testid="lang-transition"
          aria-hidden="true"
        >
          <motion.span
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.35, delay: 0.15 }}
            className="font-heading font-black text-6xl md:text-8xl tracking-tight text-[var(--accent)]"
          >
            {state.label}
          </motion.span>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
